import React from "react";
import SafeHtml from '../SafeHtml';
import './index.css';

export const TopBanner = (content, style) => {
  return (
    <div className='top-banner'>
      <SafeHtml html={content.content} />
    </div>
  )
}